export const mapReactionTypeToEmoji = {
    workout: require('~/assets/emojis/flexed-biceps.png'),
    break: require('~/assets/emojis/sleeping-face.png'),
    today: require('~/assets/emojis/smirking-face.png'),
};
